import { useFormik } from "formik";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { object, string } from "yup";

import styled from "@emotion/styled";

import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { PaperStyles } from "components/Paper/index.style";
import Spinner from "components/Spinner";
import VendorHero from "components/VendorHero";
import { VendorThemeContext } from "contexts/vendorContext";
import { MY_ACCOUNT } from "router/paths";
import { login } from "services/login";
import { breakpoints } from "styles/utils";
import { getProviders } from "services/providers";

const EmailField = styled(TextField)`
  // & input:-internal-autofill-selected {
  //   appearance: unset !important;
  //   background-image: unset !important;
  //   background-color: unset !important;
  //   color: unset !important;
  // }
  // & input:-webkit-autofill {
  //   appearance: unset !important;
  //   background-image: unset !important;
  //   background-color: unset !important;
  //   color: unset !important;
  // }
`;

const PaperContainer = styled(PaperStyles)`
  padding: 100px 16px;
  margin-inline: 16px;
  @media (min-width: ${breakpoints.large}) {
    width: 1170px;
    padding-bottom: 230px;
    margin-inline: 0px;
  }
`;

const Content = styled.section`
  @media (min-width: ${breakpoints.small}) {
    width: 300px;
    margin: 0 auto;
  }
`;

const HeroContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 0;
  > * {
    grid-template-columns: unset;
  }
`;

const validationSchema = object({
  login: string().required("Usuário é obrigatório"),
  password: string().required("Senha é obrigatório"),
  isp_identifier: string().required("Provedor é obrigatório"),
});

const Login = () => {
  const navigate = useNavigate();
  const { vendorTheme } = useContext(VendorThemeContext);
  const [error, setError] = useState<{ message?: string } | undefined>(
    undefined
  );

  const [providers, setProviders] = useState<any[]>([]);

  useEffect(() => {
    const fetchProviders = async () => {
      const response = await getProviders();
      if (response && response?.data.length > 0) {
        setProviders(response?.data);
      }
    };
    fetchProviders();
  }, []);

  const handleSubmit = async (values: {
    login: string;
    password: string;
    isp_identifier: string;
  }) => {
    setError(undefined);
    const auth = await login({
      ...values,
    });

    if (!auth?.authenticated) {
      setError({ message: auth?.message });
    } else {
      formik.resetForm();
      setError(undefined);
      navigate(MY_ACCOUNT);
    }
  };

  const initialValues = {
    login: "",
    password: "",
    isp_identifier: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
  });

  const handleProviderChange = (event: any) => {
    formik.setFieldValue("isp_identifier", event.target.value);
  };

  return (
    <PaperContainer backgroundColor={vendorTheme?.secondaryColor}>
      <Content>
        <HeroContainer>
          <VendorHero />
        </HeroContainer>
        <form onSubmit={formik.handleSubmit} style={{ marginTop: 28 }}>
          <FormControl
            fullWidth
            style={{ marginBottom: 12 }}
            error={!!formik.errors.isp_identifier}
          >
            <InputLabel
              id="demo-simple-select-label"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 8,
              }}
            >
              <span>Provedor</span>
              {providers.length === 0 && <Spinner />}
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={formik.values.isp_identifier}
              label="Provedor"
              onChange={handleProviderChange}
              disabled={providers.length === 0}
            >
              {providers.map((item) => (
                <MenuItem key={item.isp_identifier} value={item.isp_identifier}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{formik.errors?.isp_identifier}</FormHelperText>
          </FormControl>
          <EmailField
            style={{ marginBottom: 12 }}
            variant="outlined"
            fullWidth
            id="login"
            name="login"
            label="Usuário"
            value={formik.values.login}
            onChange={formik.handleChange}
            error={formik.touched.login && Boolean(formik.errors.login)}
            helperText={formik.touched.login && formik.errors.login}
          />
          <TextField
            variant="outlined"
            fullWidth
            id="password"
            name="password"
            label="Senha"
            type="password"
            value={formik.values.password}
            onChange={formik.handleChange}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
          />
          <Button
            color="primary"
            variant="contained"
            fullWidth
            type="submit"
            style={{ marginTop: 32, backgroundColor: "#FC1C38" }}
            disabled={formik.isSubmitting}
          >
            {formik.isSubmitting ? <Spinner /> : "Entrar"}
          </Button>
        </form>
        {error && (
          <Typography variant="body1" style={{ marginTop: 24, color: "red" }}>
            {error?.message}
          </Typography>
        )}
      </Content>
    </PaperContainer>
  );
};

export default Login;
